﻿import {translation} from "@2d-front-monorepo/core";
import {FeeDisplayLayout, formatCurrency, ParkingFeeDisplay, PriceBreakdown} from "@2d-front-monorepo/permits-business";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {JSX} from "react";

export function FooterComponent({price, layout}: { price?: PriceBreakdown, layout?: FeeDisplayLayout }): JSX.Element | undefined {
	if (price == null || price.total === 0) {
		return undefined;
	}

	return (
		<div className="card">
			{layout == null
				? <footer className="layout horizontal">
					<span className="flex">{translation(PermitTranslations.price)}</span>
					<span className={"tabular-nums"}>{formatCurrency(price.total)}</span>
				</footer>
				: <ParkingFeeDisplay price={price} layout={layout}/>
			}
		</div>
	);
}
